import React, { useCallback, useEffect, useState } from 'react'
import { Alert, Badge, Button, Card, Container, ProgressBar, Spinner, Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import axiosInstance from '../services/axiosInterceptor'
import { PROJECT_STATUS, fmtBaht, fmtDateTH } from './aoShared'

// โครงการที่ฉันรับผิดชอบ — ครูทุกคน (รายงานผลผ่านหน้า ProjectDetail)
export default function MyProjects() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const fetchData = useCallback(async () => {
    setLoading(true)
    setError('')
    try {
      const res = await axiosInstance.get('/api/ao/my/projects')
      if (res.data.success) setProjects(res.data.data)
    } catch (err) {
      setError(err.response?.data?.message || 'โหลดข้อมูลไม่สำเร็จ')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { fetchData() }, [fetchData])

  return (
    <>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <Container fluid>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4 className="main-title mb-0">
              <i className="ri-bar-chart-box-line me-2 text-primary" />
              โครงการที่ฉันรับผิดชอบ
            </h4>
          </div>

          {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}

          {loading ? (
            <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
          ) : (
            <Card className="card-one">
              <Card.Body className="p-0">
                {projects.length === 0 ? (
                  <div className="text-center text-muted py-4">ยังไม่มีโครงการที่คุณรับผิดชอบ</div>
                ) : (
                  <Table responsive hover className="mb-0 fs-sm">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: 80 }}>ปี</th>
                        <th>ชื่อโครงการ</th>
                        <th className="text-end" style={{ width: 120 }}>งบประมาณ</th>
                        <th style={{ width: 160 }}>เบิกจ่าย</th>
                        <th style={{ width: 170 }}>ระยะเวลา</th>
                        <th style={{ width: 130 }}>สถานะ</th>
                        <th style={{ width: 120 }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {projects.map(p => {
                        const st = PROJECT_STATUS[p.pj_status] || PROJECT_STATUS.planned
                        const budget = Number(p.pj_budget || 0)
                        const spent = Number(p.pj_spent || 0)
                        const pct = budget > 0 ? Math.min(100, Math.round(spent / budget * 100)) : 0
                        return (
                          <tr key={p.pj_id}>
                            <td>{p.pj_year}</td>
                            <td className="fw-semibold">{p.pj_name}</td>
                            <td className="text-end">{fmtBaht(budget)}</td>
                            <td>
                              <ProgressBar now={pct} variant={pct > 100 ? 'danger' : 'info'} style={{ height: 8 }} className="mb-1" />
                              <div className="text-muted" style={{ fontSize: '0.72rem' }}>{fmtBaht(spent)} บาท</div>
                            </td>
                            <td>{fmtDateTH(p.pj_start)} - {fmtDateTH(p.pj_end)}</td>
                            <td><Badge bg={st.bg}>{st.label}</Badge></td>
                            <td className="text-end">
                              <Button as={Link} to={`/admin-office/projects/${p.pj_id}`} size="sm" variant="primary">
                                รายงานผล
                              </Button>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            </Card>
          )}
        </Container>
      </div>
      <Footer />
    </>
  )
}
